import Flipper from "./Flipper";
import Flipped from "./Flipped"; // for umd build

export default {
  Flipper: Flipper,
  Flipped: Flipped
};
export { default as Flipper } from "./Flipper";
export { default as Flipped } from "./Flipped";